module.exports = __webpack_public_path__ + "static/img/yxDLogo.ea81c6f5.png";